import { PaxErrorPage, useTranslation } from "@ncino/pax-ui";
import { ErrorComponentProps } from "@/shared/errors";
import { SystemConfigs } from "@ncino/pa-authentication-client-webclient";

export function MarketplaceAccessDeniedPage(_props: ErrorComponentProps) {
  const { t } = useTranslation();

  return (
    <PaxErrorPage
      header={t("marketplaceAccessDenied.header")}
      subtext=""
      actionLabel={t("marketplaceAccessDenied.actionLabel")}
      onAction={() => {
        window.location.href = SystemConfigs.paBaseUrl();
      }}
    />
  );
}
